import { Component, Input, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { AgentService } from '@core/services/agent.service';
import { CommonService } from '@core/services/common.service';
import { ModalcloseService } from '@core/services/modalclose.service';
import { UserService } from '@core/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { AgentDetailsText } from '@shared/models/agent-details-text';
import { PrefferedAgent } from '@shared/models/preffered-agent';
import { User } from '@shared/models/user';

@Component({
    selector: 'app-preffered-agent',
    templateUrl: './preffered-agent.component.html',
    styleUrls: ['./preffered-agent.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrefferedAgentComponent implements OnInit {
    // modal
    @ViewChild('prefferedAgent')
    templateRef: TemplateRef<any>;
    templateDialogRef: NxModalRef<any>;

    public isVisiblePopup = true;
    /**
     * Agent not set
     */
    // agents list
    public agents: PrefferedAgent[];
    public currentAgent: PrefferedAgent;
    public setButtonText: string;
    public changeAgent: boolean = false

    private loggedUser: User;
    private returnUrl = null;

    constructor(
        public dialogService: NxDialogService,
        public commonService: CommonService,
        private agentService: AgentService,
        private translateService: TranslateService,
        private userService: UserService,
        private modalCloseService: ModalcloseService,
    ) {
        this.userService.getLoggedUser().subscribe(res => this.loggedUser = res);

        this.translateService.get('common.ok').subscribe(trans => {
            this.setButtonText = trans
        })
    }

    ngOnInit(): void {
        if (this.commonService.PrefferedAgentOpenModalSubscription === undefined) {
            this.commonService.PrefferedAgentOpenModalSubscription = this.commonService.PrefferedAgentOpenModalFunction.subscribe(
                (url) => { this.openModal(url); });
        }

        // logged user current agent
        this.currentAgent = null;
        if (this.loggedUser.prefferedAgent != null && this.loggedUser.prefferedAgent.agentId) {
            this.currentAgent = {
                id: this.loggedUser.prefferedAgent.agentId,
                name: this.loggedUser.prefferedAgent.agentName,
                specialty: this.loggedUser.prefferedAgent.agentChannel,
                avatar: "https://i.ibb.co/G3zHGdK/person.png",
                phoneNumber: this.loggedUser.prefferedAgent.agentMobilAgn,
                addressEmail: this.loggedUser.prefferedAgent.agentEmailAgn,
                website: this.loggedUser.prefferedAgent.agentUrl
            } as PrefferedAgent;
            
            this.prefferedAgentMapper(this.currentAgent);
        } else {
            this.currentAgent = {
                id: null,
                name: "Allianz",
                agentNo: "",
                specialty: "",
                avatar: "assets/images/allianz-logo-eagle.svg",
                phoneNumber: "+421 2 50 122 222",
                addressEmail: "allianz@allianz.sk",
                website: "https://www.allianz.sk/",
                cnt: -1
            } as PrefferedAgent;
        }

        // all agents

        this.agents = [];
        this.agentService.getAgents().subscribe(agents => {

            let tmpAgents = {};
            for (let i = 0; i < agents.list.length; i++) {
                let a: PrefferedAgent = null;
                if (agents.list[i].agentChannel !== 'INT' && agents.list[i].agentChannel !== 'CC' && agents.list[i].agentChannel !== 'UNK') {
                    if (agents.list[i].agentId == null || agents.list[i].agentNo == null || agents.list[i].agentName == null) {
                        continue;
                    }

                    a = {
                        id: agents.list[i].agentId,
                        agentNo: agents.list[i].agentNo,
                        name: agents.list[i].agentName,
                        specialty: agents.list[i].agentChannel,
                        avatar: null,
                        phoneNumber: agents.list[i].agentMobilAgn,
                        addressEmail: agents.list[i].agentEmailAgn,
                        website: agents.list[i].agentUrl,
                        cnt: 1,
                        dateBegin: new Date(agents.list[i].dateBegin).getTime()
                    };
                }

                if (a != null) {
                    if (tmpAgents[a.id] == undefined) {
                        a = this.prefferedAgentMapper(a);
                        tmpAgents[a.id] = a;
                    } else {
                        tmpAgents[a.id].cnt++;

                        if (tmpAgents[a.id].dateBegin < a.dateBegin) {
                            tmpAgents[a.id].dateBegin = a.dateBegin;
                        }
                    }
                }
            }

            tmpAgents[0] = {
                id: null,
                name: "Allianz",
                agentNo: "",
                specialty: "",
                avatar: "assets/images/allianz-logo-eagle.svg",
                phoneNumber: "+421 2 50 122 222",
                addressEmail: "allianz@allianz.sk",
                website: "https://www.allianz.sk/",
                cnt: -1
            } as PrefferedAgent;

            this.agents = Object.values(tmpAgents);
            this.agents.sort(function (a, b) {
                if ((b.cnt - a.cnt) < 0) {
                    return -1;
                } else if ((b.cnt - a.cnt) > 0) {
                    return 1;
                } else {
                    return b.dateBegin - a.dateBegin;
                }
            });
        });
    }

    ngAfterViewInit() {
        this.agentService.prefferedAgentComponent$.subscribe(t => {
            if (t) {
                this.openModal();
            }
        });

        this.modalCloseService.prefferedAgentCloseModal$.subscribe(t => {
            if (t) {
                this.closeModal();
            }
        });
    }

    setAgent = ($event: PrefferedAgent): void => {
        this.agentService.setPrefferedAgent($event).subscribe(res => {
            if ($event.id == res.id) {
                if (this.returnUrl) {
                    this.closeModal();
                    if (res.id != null) {
                        this.agentService.getPrefferedAgentToken(res.agentNo).subscribe(token => {
                            window.open(this.returnUrl + '?agent=' + token['token'], '_blank');
                        });
                    } else {
                        window.open(this.returnUrl, '_blank');
                    }
                } else {
                    window.location.reload();
                }

            }
        });
    };

    changePopup($event) {
        if (!$event) {
            this.closeModal();
        }
    }

    openModal(url?: string) {

        if (url != null && url.length > 0) {
            this.returnUrl = url;
        }

        this.templateDialogRef = this.dialogService.open(this.templateRef, { 
            showCloseIcon: !!this.currentAgent,
            disableClose: !this.currentAgent,
            width: "814px",
            maxWidth: "814px"
        });

        this.templateDialogRef.afterClosed().subscribe(() => {
            this.changeAgent = false;
        })
    }

    closeModal() {
        if (this.templateDialogRef) {
            this.templateDialogRef.close();
        }
    }

    /**
     * translations
     */
    getText() {
        return this.translateService.instant('preffered-agent.not-set.text');
    }

    getSubmitBtnText() {
        return this.translateService.instant('preffered-agent.not-set.submitBtnText');
    }
    /**
     * /translations
     */



    selectedAgent = ($event): void => {
        this.closeModal();
    };

    editAgent = (): void => {
        this.changeAgent = true;
    };


    private prefferedAgentMapper(agent: PrefferedAgent) {

        if (['BAN', 'MA', 'ŽM'].find(x => x === agent.specialty)) {
            this.translateService.get('preffered-agent.specialty.broker').subscribe(t => {
                agent.specialty = t;
                if (agent.avatar == null) {
                    agent.avatar = "assets/images/user-light-blue.svg";
                }
            });
        } else if (['CC', 'FO', 'INT'].find(x => x === agent.specialty)) {
            this.translateService.get('preffered-agent.specialty.allianz').subscribe(t => {
                agent.specialty = t;
                //agent.phoneNumber = '+421 2 50 122 222';
                //agent.addressEmail = 'allianz@allianz.sk'
                if (agent.avatar == null) {
                    agent.avatar = "assets/images/user-light-blue.svg";
                }
            });
        } else {
            this.translateService.get('preffered-agent.specialty.agent').subscribe(t => {
                agent.specialty = t;
                if (agent.avatar == null) {
                    agent.avatar = "assets/images/user-light-blue.svg";
                }
            });
        }
        return agent;
    }

    getChangeButtonText(): string
    {
        let editButtonText = '';
        this.translateService.get('profile.texts.change').subscribe(trans => {
            editButtonText = trans
        })
        return editButtonText;
    }

    getAgentDetailsText(): AgentDetailsText{
        const agentDetailsText = new AgentDetailsText();

        this.translateService.get('profile.texts.mobile').subscribe( trans => {
            agentDetailsText.phoneNumber = trans;
        });

        this.translateService.get('profile.texts.email-address').subscribe( trans => {
            agentDetailsText.email = trans;
        })

        this.translateService.get('profile.texts.website').subscribe( trans => {
            agentDetailsText.website = trans;
        })

        return agentDetailsText;
    }
}
